import React from 'react';
import { SurveyQuestionType } from 'freemium-survey-components';
import { StyledDateTime } from './styles';

type DateTimeProps = {
  question: SurveyQuestionType;
  answer: string;
};

const DateTime = ({ answer, question }: DateTimeProps) => {
  const dateTimeAnswer = React.useMemo(() => {
    const [datePart, timePart] = answer?.split('|') || [];
    if (
      question?.type_info?.meta?.time_zone &&
      question?.type_info?.meta?.question_format === 'DATE_TIME'
    ) {
      return `${datePart} (${timePart})`;
    }
    return datePart;
  }, [answer]);

  return (
    <StyledDateTime>
      <div className="date-time-answer">{dateTimeAnswer}</div>
    </StyledDateTime>
  );
};

export default DateTime;
